import ajax from './ajax'

// 公共-图片素材
export const getDefaultImageSource = () => ajax.get('/default/image-source')
// 公共-文章内容详情
export const getDefaultArticleInfo = (id) => ajax.get(`/default/article-info?id=${id}`)
// 公共-文章搜索
export const postDefaultSearchArticle = (params) => ajax.post(`/default/search-article`,params)
// 公共-产品搜索
export const postDefaultSearchProduct = (params) => ajax.post(`/default/search-product`,params)
// 公共-导航文章列表
export const postDefaultNavArticleList = (params) => ajax.post(`/default/nav-article-list`,params)
// 文章详情（上、下一个）
export const getDefaultLastNext = (id,scene,nav_id,keyword) => ajax.get(`default/last-next?id=${id}&scene=${scene}&nav_id=${nav_id}&keyword=${keyword}`)


//走进修正
export const getIntroIndex = () => ajax.get('/intro/index')
//新闻中心首页
export const getNewsIndex = () => ajax.get(`/news/index`)
//新闻中心导航文章列表
export const getNewsArticleList = (params) => ajax.post(`/news/article-list`,params)
//科技研发首页
export const getTechnologyIndex = () => ajax.get(`/technology/index`)
//集团产品 产品分类
export const getProductCategoryList = () => ajax.get(`/product/category-list`)
//集团产品 产品列表
export const postProductList = (params) => ajax.post(`/product/product-list`,params)
//集团产品 产品详情
export const postProductInfo = (id) => ajax.post(`/product/product-info`,id)






// 党团建设首页
export const getPoliticalPartyIndex = () => ajax.get(`/political-party/index`)
// 人力资源首页
export const getHumanResourceIndex = () => ajax.get(`/human-resource/index`)
// 人力资源招聘信息
export const postJobList = (page,page_size) => ajax.post(`/human-resource/job-list`,page,page_size)
// 人力资源招聘信息
export const postJobDetail = (params) => ajax.post(`/human-resource/job-detail`,params)
//人力资源底部信息
export const postBottomDetail = (id) => ajax.post(`/human-resource/human-resource-info`, id)
// 人力资源领导人详情
export const getLeaderDetail = (params) => ajax.get(`human-resource/leader-detail`,params)

// 爱心修正首页
export const getKindnessIndex = (params) => ajax.get(`/kindness/index`,params)
// 爱心修正查看更多
export const getKindnessMore = (params) => ajax.post(`/kindness/more-chosen`,params)
// 关于我们首页
export const getAboutIndex = () => ajax.get(`/about/index`)
//产业信息列表
export const getcompany = () => ajax.get(`about/company`)



